import { KuxCardPlaceholderType } from '@kaltura-ott/tvpil';
import { observable } from 'mobx';

/**
 * CardPlaceholder are created automatically for rails.
 * Each rail must have getRestoreData function that converts placeholders to real cards
 */
export class CardPlaceholder {
  @observable.ref public data: KuxCardPlaceholderType;

  public get id(): number {
    return this.data.assetId;
  }

  public get isProgramRecord(): boolean {
    return !!this.data.isRecordProgram;
  }

  constructor(data: KuxCardPlaceholderType) {
    this.data = data;
  }
}
